export { Icon } from './Icon';
export type { IconProps } from './Icon';
